import { useState } from 'react';

import { KycFlow } from '#src/components/kyc/KycFlow/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import { AccountVerificationContext } from './AccountVerification/AccountVerificationContext.tsx';
import { IdentityVerificationCTA } from './AccountVerification/IdentityVerificationCTA/index.tsx';
import { JonumVerificationInProgress } from './JonumVerificationInProgress/index.tsx';

type Props = {
  onDone: () => void;
};

export const JonumKycPromptView = ({ onDone }: Props) => {
  const [showKycFlow, setShowKycFlow] = useState(false);
  const { currentUser } = useCurrentUserContext();

  if (showKycFlow) {
    return (
      <KycFlow
        onDone={onDone}
        renderVerificationInProgress={({ onDone: onJonumDone }) => (
          <JonumVerificationInProgress onDone={onJonumDone} />
        )}
      />
    );
  }

  return (
    <AccountVerificationContext.Provider
      value={{ onSkip: onDone, updateData: () => {}, loading: false }}
    >
      <IdentityVerificationCTA
        onNext={() => setShowKycFlow(true)}
        gracePeriodExpiresAt={
          currentUser?.jonumVerification?.gracePeriodExpiresAt
        }
      />
    </AccountVerificationContext.Provider>
  );
};
